import {Component, viewChild, inject} from '@angular/core';
import {NavigationComponent} from "../navigation/navigation.component";
import {ModalDirective} from "ngx-bootstrap/modal";
import {NgForOf, NgIf} from "@angular/common";
import {FormsModule, NgForm} from "@angular/forms";
import {DataService} from "../services/data.service";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-price',
    templateUrl: './price.component.html',
    styleUrl: './price.component.scss',
    imports: [NavigationComponent, ModalDirective, NgIf, FormsModule, NgForOf]
})
export class PriceComponent {

    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    contactModal = viewChild.required<ModalDirective>('contactModal');

    plans: string[] = [
        'Klein (50 QR-Codes)',
        'Mittel (150 QR-Codes)',
        'Groß (300 QR-Codes)',
        'Individuell (Mehr als 300 QR-Codes)',
    ];

    selectedPlan: string = '';

    openContact(plan: string) {
        // Default to the clicked plan if provided; otherwise, keep current selection or empty
        this.selectedPlan = this.plans.includes(plan) ? plan : (this.selectedPlan || '');
        this.contactModal().show();
    }

    sendRequest(form: NgForm) {
        if (!form?.valid) return;

        const v = form.value;

        // Compose message with submitted data
        const message = [
            'Neue Angebotsanfrage über die Preisseite:',
            `Firma: ${v.company || ''}`,
            `Anschrift: ${v.address || ''}`,
            `Ansprechpartner: ${v.contact || ''}`,
            `E-Mail: ${v.email || ''}`,
            `Paket: ${v.plan || this.selectedPlan || ''}`,
            `Nachricht: ${v.message || ''}`,
        ].join('\n');

        this.dataService.request('Contact/requestOffer', {
            message,
        }).subscribe({
            next: () => {
                this.contactModal().hide();
                form.resetForm({plan: ''});
                this.selectedPlan = '';
                this.toastrService.success('Anfrage erfolgreich gesendet', 'Erfolg');
            },
            error: () => {
                //this.contactModal?.hide();
                this.toastrService.error('Fehler beim Senden der Anfrage', 'Fehler');
            }
        });
    }
}
